import { XesAxios } from '@xes/terra-utils'
import axios from 'axios'
const BASEURL = 'https://booster.xueersi.com'
export default {
  // 检测登录态 - 首页
  checkLogin() {
    return XesAxios.post('https://login.xueersi.com/LoginV1/checkLogin', {
      user_info: 1
    })
  },
  // 获取报名审核结果
  censorResult() {
    return XesAxios.get(`${BASEURL}/teacher/applyCensorResult`)
  },
  // 活动介绍页活动状态接口
  activityPage(params) {
    return XesAxios.get(`${BASEURL}/teacher/activityPage?isShow=${params.isShow}`)
  },
  // 上传图片接口 需要登陆态
  uploadImg(params) {
    return axios({
      method: 'post',
      url: `${BASEURL}/teacher/upload`,
      data: params.file,
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryLLsdWMEHHIrMk6wx'
      }
    })
  },
  // 提交信息 需要登陆态
  addInfo(params) {
    return XesAxios.post(`${BASEURL}/teacher/addInfo`, params)
  },
  // 获取上次提交的信息
  getInfo() {
    return XesAxios.post(`${BASEURL}/teacher/getInfo`)
  },
  // 修改申领信息
  modifyInfo(params) {
    return XesAxios.post(`${BASEURL}/teacher/modifyInfo`, params)
  },
  checkWxBind(params) {
    return XesAxios.post('https://weixin.xueersi.com/User/checkBind', params)
  },
  checkUserLoginStatus() {
    return XesAxios.get(`${BASEURL}/teacher/checkUserLoginStatus`)
  },
  // 获取课程筛选条件
  courseFilterList(params) {
    return XesAxios.get(`${BASEURL}/teacher/courseFilterList`, params)
  },

  // 获取课程列表
  getClassList(params) {
    return XesAxios.get(`${BASEURL}/teacher/courseListByFilter`, params)
  },

  // 获取已选课程
  getSelectedClass() {
    return XesAxios.get(`${BASEURL}/teacher/courseChoseInfo`)
  },

  // 是否可以领券
  isReceiveCoupon(params) {
    return XesAxios.get(`${BASEURL}/teacher/receiveCoupon`, params)
  },

  // 获取班级id
  getClassId(courseId) {
    return XesAxios.get('//growth.xueersi.com/api/ac/summerCourse/getCourseClassId', {
      params: {
        courseId
      }
    })
  },

  // 获取购买链接地址（需判断登录状态）
  getPayUrl(courseId) {
    return XesAxios.get('//growth.xueersi.com/api/common/getPayUrl', {
      params: {
        courseId,
        source: 44
      }
    })
  }
}
